export const mode = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'development' : 'production'
export const configuration = window.GLOBAL_CONFIGURATION[mode]
export const API = mode === 'production' ? configuration.API_HOST[window.location.hostname] : configuration.API_HOST;
export const API_PORT = API?.substring(API?.lastIndexOf(':') + 1)
export const API_DOMAIN = API?.substring(0, API?.lastIndexOf(':'))

export const PortalToken = window.GLOBAL_CONFIGURATION.portalToken

export const Languages = {
	EL: 'el',
	EN: 'en',
}

export const Permissions = {
	BeAdmin: "ADMIN_CONTENT",
}

export const Roles = {
	Admin: 1
}

export const ATTACHMENTS_RELATIVE_PATH = '/attachments/'

export const BulkImportStatus = {
	AllSuccessful: 1,
	AllErrors: 2,
	SucceededWithErrors: 3,
	NothingToDo: 4,
}

export const DocsDownloadTypes = {
	CustomerExcel: 1,
	GDPR: 2
}

export const CustomerApplicationsStatus = [
	{id: '1', Description: {en: 'Drafted', el: 'Ανοιχτή για καταχώριση'} },
	{id: '2', Description: {en: 'Submitted', el: 'Υποβλήθηκε από τον πελάτη'} },
	{id: '3', Description: {en: 'Ready for bank submission', el: 'Σε αναμονή υποβολής στην Τράπεζα'} },
	{id: '4', Description: {en: 'Successfully submitted', el: 'Καταχωρίστηκε επιτυχώς στην Τράπεζα'} },
	{id: '5', Description: {en: 'Failed submission', el: 'Αποτυχία καταχώρισης στην Τράπεζα'} },
]

export const CustomerApplicationsLanguages = [
	{id: '1', Description: {en: 'Greek', el: 'Ελληνικά'} },
	{id: '2', Description: {en: 'English', el: 'Αγγλικά'} },

]